import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=49d8122a&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d8122a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49d8122a')) {
      api.createRecord('49d8122a', component.options)
    } else {
      api.reload('49d8122a', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=49d8122a&scoped=true&", function () {
      api.rerender('49d8122a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/calendar/Index.vue"
export default component.exports